(ns motorsaif.request-utils
  (:require [motorsaif.time :as time]))

(def ^:private service-type->request-type
  {:repairs :repair
   :upgrades :upgrade
   :used-parts :part
   :new-parts :part})

(defn filter->predicate [request-filter]
  (let [{:keys [makes year type tag]} request-filter
        {:keys [min max]} year
        make-path [:request/object :car/make]
        models (set (apply concat (vals makes))) ;; NOTE NAIVE, will show makes with same model name
        makes (keys makes)
        model-path [:request/object :car/model]
        tag-path [:request/category :db/id]
        type-path [:request/type :db/ident]
        year-path [:request/object :car/year]
        part-condition-path [:part/condition :db/ident]

        part-condition (when
                           (or
                            (type :used-parts)
                            (type :new-parts))
                         (fn [condition]
                           (condp = condition
                             :used (type :used-parts)
                             :new (type :new-parts)
                             :either)))
        preds (-> []
                  (cond->
                      type (conj #((set (map service-type->request-type type)) (get-in % type-path)))
                      part-condition (conj #(part-condition (get-in % part-condition-path)))
                      tag (conj #((set tag) (get-in % tag-path)))
                      makes (conj #((set makes) (get-in % make-path)))
                      (seq models) (conj #(models (get-in % model-path)))
                      min (conj #(>= (get-in % year-path) min))
                      max (conj #(<= (get-in % year-path) max))))]
    (apply every-pred preds)))

(defn match [filter req]
  ((filter->predicate filter) req))

(defn match-any? [filters req]
  (some #(match % req) filters))

(defn filter-requests [preds reqs]
  (if (seq preds)
    (distinct (filter #(match-any? preds %) reqs))
    reqs))

(defn older-than [requests days]
  (->> (filter
        #(time/before?
          (:date-time/created %)
          (time/date-minus :days days)) requests)))

(defn businesses-matching
  "Given a request, return any business who has at least once request filter
  whose parameters match request"
  [request businesses]
  (filter #(match-any? (get-in % [:business/misc :filters]) request)
          businesses))

(defn last-interaction-status
  [statuses]
  (->> statuses
       (map
        (fn [{:keys [value]}]
          (let [audit-user-id (get-in value [:meta :audit-user-id])
                ret (assoc (:data value)
                           :audit-user-id audit-user-id)]
            ret)))
       (sort-by :date >)
       first))
